export const Icons = [
 {
        nom: "Fenêtres et portes fenêtres",
        pics: [
          { nom: "villa M", projet: "villa M", descreption: "villa M" },
          { nom: "villa M2", projet: "villa M", descreption: "villa M" },
           { nom: "villa M3", projet: "villa M", descreption: "villa M" },
              { nom: "screen", projet: "screen", descreption: "screen" },
               { nom: "villa H", projet: "villa H", descreption: "villa H" },
        ],
      },
      {
        nom: "Volet roulant",
        pics: [
         { nom: "villa M", projet: "villa M", descreption: "villa M" },
            { nom: "villa M2", projet: "villa M", descreption: "villa M" },
               { nom: "villa M3", projet: "villa M", descreption: "villa M" },
                  { nom: "villa M4", projet: "villa M", descreption: "villa M" },
        ],
      },
  

      {
        nom: "Mur Rideaux",
        pics: [
           { nom: "square", projet: "square", descreption: "square" },
          { nom: "screen", projet: "screen", descreption: "screen" },
           { nom: "screen2", projet: "screen", descreption: "screen" },
          { nom: "square2", projet: "square", descreption: "square" },
        ],
      },
      {
        nom: "brises soleil",
        pics: [
        { nom: "waterfront", projet: "waterfront", descreption: "waterfront" },
          { nom: "waterfront1", projet: "waterfront", descreption: "waterfront" },
            { nom: "waterfront2", projet: "waterfront", descreption: "waterfront" },
           { nom: "zen", projet: "zen", descreption: "zen" },
              { nom: "zen2", projet: "zen", descreption: "zen" },
                { nom: "villa H", projet: "villa H", descreption: "villa H" },
           { nom: "villa H2", projet: "villa H", descreption: "villa H" },
        ],
      },
 
  {
    nom: "Porte automatique",
     pics: [
           { nom: "evolo", projet: "evolo", descreption: "evolo" },
         { nom: "evolo2", projet: "evolo", descreption: "evolo" },
        ],
  },
 
      {
        nom: "Cabine de douche",
        pics: [
         { nom: "villa M", projet: "villa M", descreption: "villa M" },
            { nom: "villa M2", projet: "villa M", descreption: "villa M" },
               { nom: "villa M3", projet: "villa M", descreption: "villa M" },
                  { nom: "projet x"  },
        ],
      },
      {
        nom: "Garde corps",
        pics: [
        { nom: "villa M", projet: "villa M", descreption: "villa M" },
            { nom: "villa M2", projet: "villa M", descreption: "villa M" },
               { nom: "villa M3", projet: "villa M", descreption: "villa M" },
                 { nom: "villa M4", projet: "villa M", descreption: "villa M" },
                 
                  { nom: "projet-x" },
        ],
      },
       { nom: "Pergola",
         pics: [
           { nom: "projet x" },   { nom: "projet x2" },
                { nom: "projet x3" },   { nom: "projet x4" },
        ],
       },
      { nom: "Cloison",
         pics: [
         { nom: "screen", projet: "screen", descreption: "screen" },
           { nom: "vital cube", projet: "vital cube", descreption: "vital cube" },
            { nom: "vital cube2", projet: "vital cube", descreption: "vital cube" },
             { nom: "vital cube3", projet: "vital cube", descreption: "vital cube" },
              { nom: "lighthouse", projet: "lighthouse", descreption: "lighthouse" },
        ],
       },
      


 
];
export const Realisation = [
  { nom: "square", title: "Square", category: "professionnels" },
  { nom: "screen", title: "Screen", category: "professionnels" },
  { nom: "waterfront", title: "Waterfront", category: "multiresidentiels" },
  { nom: "opus", title: "Opus", category: "professionnels" },
  { nom: "zen", title: "Zen", category: "professionnels" },
  { nom: "vital cube", title: "Vital Cube", category: "professionnels" },
  { nom: "evolo", title: "Evolo", category: "multiresidentiels" },
  { nom: "lighthouse", title: "Lighthouse", category: "residentiels" },
  { nom: "irix", title: "Irix", category: "multiresidentiels" },
  { nom: "villa H", title: "villa H", category: "residentiels" },
  { nom: "villa M", title: "villa M", category: "residentiels" },
];

export const RealisationDetail = [
  {
    name: "waterfront",
    title: "waterfront Sousse",
    descreption:
      "   • Menuiserie aluminium : Ellouze Alu. <br/> • Architecture : Ark Architecture (Bilel Khemakhem) + Lab Architects. <br/> • Emplacement : Sousse. <br/> • Surface : 4.000 m². <br/> Ellouze Alu signe sur Waterfront une intervention unique alliant design et performance : <br/> – Brise-soleil à effet bois, avec lames verticales, offrant à la fois esthétique et protection solaire. <br/> – Façades mur-rideau assurant luminosité, isolation et modernité. <br/> – Panneaux composites (Alucobond) pour une finition haut de gamme et durable. ",
    projets: ["1","2", "3", "4","5","6","7"],
  },
  {
    name: "evolo",
    title: "evolo jardin de carthage",
    descreption:
      " • Menuiserie aluminium : Ellouze Alu. <br/> • Architectes :  ark architecture: bilel khemakhem / AUDA :mohamed khemakhem et nejib Saadallah. <br/>  • Maître d'ouvrage : PROMED. <br/> • Emplacement : Les Jardins de Carthage- Tunis. <br/> • Surface : 17.000m². <br/> Evolo, un projet marquant,  réalisé  par Ellouze Alu. l’entreprise a conçu le mur rideau collé en séries EX 45 et EX 60 Prestige TPR, tout en assurant la fabrication et la pose de l’ensemble des menuiseries aluminium des 107 appartements. evolo un projet marquant réalisé par ellouze alu. l’entreprise a conçu le mur rideau  ",
    projets: ["1","2", "3", "4","5",'6','7','8'],
  },
  {
    name: "screen",
    title: "Screen Berges du Lac",
    descreption:
      "    • Menuiserie aluminium : ellouze alu. <br/> • Architecture : AUDA architecture + ARK architecture. <br/>  • Surface : 23.000 m². <br/> • Maître d’ouvrage : zen immobilière. <br/> • Emplacement : les berges du lac.<br/> The Screen a bénéficié de l’expertise d’Ellouze Alu à travers la réalisation d’une façade lisse à vitrage extérieur accroché , mur rideaux série 52000 horizon plus TPR couleur S15 Ce type de mur rideaux nous permet d’obtenir une façade économique esthétique et thermique avec des panneaux vitré de grand dimensions en double vitrage feuilleté jusqu'à 30mm d'épaisseur.Un résultat à la fois moderne, élégant et parfaitement maîtrisé. ",
    projets: ["1","2", "3", "4","5","6",'7'],
  },
  {
    name: "square",
    title: "square Soukra",
    descreption:
      "   • Menuiserie aluminium : Ellouze Alu. <br/> • Architecture : Ark Architecture (Bilel Khemakhem) + AUDA (Mohamed Khemakhem et Nejib Saadallah).<br/> • Surface : 12.000 m². <br/> • Maître d’ouvrage : Square Properties. <br/> • Emplacement : La Soukra, Tunis. <br/> Pour le projet The Square, Ellouze Alu a déployé son savoir-faire à travers une façade innovante combinant plusieurs solutions de haute technicité : <br/> – Mur-rideau Spider System, conçu avec une ossature verticale en acier galvanisé habillée en Alucobond.<br/> – Vitrages fixés par des pattes d’attache en inox (1, 2 ou 4 branches) de la marque SADEF. <br/> – Dimensions exceptionnelles : vitrages de 2 m x 3 m dépassant 400 kg, et une hauteur totale de 16 m, la plus grande en Tunisie. <br/> Ce projet illustre la maîtrise technique et la capacité de Ellouze Alu à relever les défis architecturaux les plus ambitieux.",
    projets: ["1","2", "3", "4","5"],
  },
  {
    name: "opus",
    title: "opus Tunis",
    descreption:
      "    • Menuiserie aluminium : ellouze alu. <br/> • Architecture : ark architecture: Bilel khemakhem / AUDA :Mohamed Khemakhem et Nejib Saadallah.<br/> • Surface : 4.700 m² + 5900 m². <br/> • Maître d’ouvrage : Dhilel Immobilière / Ons Immobilière. <br/> • Emplacement : La zone Khaireddine Lac 3 Tunis <br/> Ellouze Alu a participé au projet Opus (10.600 m²) en mettant en œuvre une façade en mur-rideau série 52000 TPR avec un aspect VEC. La solution intègre un double vitrage smart et émaillé, tandis que les parties opaques sont réalisées en simple vitrage. Ce projet illustre la capacité d’Ellouze Alu à associer innovation, esthétisme et performance technique.",
    projets: ["1","2", "3", "4","5","6"],
  },
  {
    name: "zen",
    title: "zen Sfax",
    descreption:
      "    •  menuiserie aluminium : Ellouze Alu. <br/> • Architectes : ARK-architecture (Bilel Khemakhem) + AUDA (Mohamed Khemakhem et Nejib Saadallah). <br/>  • Emplacement : Sfax. <br/>  • Maître d’ouvrage : Zen Group. <br/> • Surface : 6.500m². <br/> Le projet Zen (2014) illustre le savoir-faire d’Ellouze Alu à travers l’intégration de vitrages feuilletés avec film coloré et de brise-soleil en aluminium gris. Ces choix apportent à la fois une esthétique moderne et une gestion optimale de la luminosité, alliant design et fonctionnalité.    ",
    projets: ["1","2", "3", "4","5","6"],
  },
    {
    name: "vital cube",
    title: "vital cube lac 2",
    descreption:
      "    • Menuiserie aluminium : ellouze alu. <br/> • Architecture : ark architecture: bilel khemakhem / AUDA :mohamed khemakhem et nejib saadallah.<br/>  • Surface :7.000 m².<br/>  • Maître d’ouvrage : PROMED.<br/>   • Emplacement : Berge du lac 2 Tunis. <br/> Ellouze Alu a contribué au projet Vital Cube à travers la réalisation de cloisons séparatives en série 16000 TPR avec double vitrage, ainsi que de garde-corps vitrés en vitrage feuilleté trempé 88.4 PVB — une intervention ciblée qui met en valeur l’expertise de l’entreprise dans les solutions intérieures élégantes et sécurisées.",
    projets: ["5","6","1","2", "3","4","7"],
  },
    {
    name: "irix",
    title: "Irix Jardins de Carthage",
    descreption:
      "    • Menuiserie Aluminium : Ellouze Alu. <br/> • Architecte : Bilel Khemakhem. <br/>  • Maître d'ouvrage : Dhilel Immobilière. <br/>  • Emplacement : Les jardins de Carthage - Tunis. <br/> • Surface : 5200m².<br/> Le projet IRIX met en avant le savoir-faire d’Ellouze Alu à travers plusieurs réalisations remarquables : un mur-rideau en série 52 TPR, une façade ventilée au design contemporain, ainsi qu’un plancher en triple vitrage offrant robustesse, sécurité et luminosité optimale. Les cloisons de séparation vitrées en série 40 viennent parfaire l’ensemble, combinant élégance et performance technique pour un résultat harmonieux et moderne.",
    projets: ["1","2", "3", "4","5","6"],
  },
    {
    name: "lighthouse",
    title: "Lighthouse Sfax ",
    descreption:
      "À Sfax, cette villa haut de gamme de 600 m², achevée en 2022, est équipée de menuiseries aluminium sur mesure d’Ellouze Alu en série EX Prestige, couleur blanc. Intégrées à la façade et aux revêtements, elles apportent esthétisme, luminosité et confort, tout en répondant aux exigences techniques et au style architectural du bâtiment.   ",
    projets: ["4","1","2", "3", "5","6"],
  },
    {
    name: "villa H",
    title: "Villa H",
  descreption:   " • Emplacement : Tunis, Tunisie <br/>  • Surface : 620m² <br/>  • Menuiserie aluminium : Ellouze Alu  <br/> • Architecte : Ark Architecture ( Bilel Khemakhem)  <br/> Réalisée en 2025, Villa H incarne l’élégance et la modernité d’une résidence haut de gamme. Ellouze Alu a pris en charge l’ensemble de la menuiserie aluminium, en optant pour des ouvrants coulissants et à la française en finition noir mat, offrant à la fois sobriété et raffinement.Les petites ouvertures ont été conçues dans le même esprit pour garantir une harmonie visuelle sur l’ensemble de la façade. Enfin, l’installation de brise-soleil à effet boisé vient sublimer l’architecture, en alliant design contemporain et protection solaire efficace. ",
    projets: ["4","6","1","2", "3","7", "5"],
  },
    {
    name: "villa M",
    title: "Villa M",
    descreption:
      "Concernant la villa M situé à Sfax en 2024, Ellouze Alu a réalisé l'ensemble des menuiseries aluminium sur mesure en série EX Prestige, couleur noir givré. Le projet comprend les gardes-corps vitrés et aluminium, les portes-fenêtres et fenêtres, la rampe d’escalier vitrée ainsi que le coulissant d’angle, offrant esthétisme, modernité et fonctionnalité.",
    projets: ["7","8","1","2", "3", "4","5","9","10"],
  },
];
